<template>
  <div class="container-fluid py-4 role-medical-page">

    <!-- ================= HEADER ================= -->
    <div class="page-header-medical d-flex justify-content-between align-items-center flex-wrap mb-4">

      <div class="title-block">
        <div class="icon-box">
          <i class="bi bi-shield-lock"></i>
        </div>

        <div>
          <h2 class="title">
            Modification du profil d’accès
          </h2>

          <p class="subtitle">
            Mise à jour des permissions du système médical
          </p>
        </div>
      </div>

      <router-link class="btn btn-outline-light btn-sm px-3 py-2"
                   :to="{ name: 'role' }">
        <i class="bi bi-arrow-left-circle me-1"></i>
        Retour
      </router-link>

    </div>

    <!-- ================= CARD ================= -->
    <div class="card medical-card p-4">

      <form @submit.prevent="submitForm">

        <!-- ROLE NAME -->
        <div class="mb-3">
          <label class="form-label">Nom du profil</label>

          <input
            v-model="roleName"
            type="text"
            class="form-control form-control-medical"
            placeholder="Ex: Médecin, Infirmier, Pharmacien..."
          />

          <small class="text-danger" v-if="errors.roleName">
            {{ errors.roleName }}
          </small>
        </div>

        <!-- TOOLBAR -->
        <div class="d-flex justify-content-between align-items-center mb-3">

          <div class="fw-bold text-primary">
            Permissions : {{ selectedPermissions.length }}
          </div>

          <div class="d-flex gap-2">
            <button type="button"
                    class="btn btn-sm btn-outline-primary"
                    @click="selectAll">
              Tout
            </button>

            <button type="button"
                    class="btn btn-sm btn-outline-danger"
                    @click="clearAll">
              Reset
            </button>
          </div>

        </div>

        <!-- SEARCH -->
        <div class="mb-3">
          <input
            v-model="search"
            class="form-control form-control-medical"
            placeholder="Rechercher une permission..."
          />
        </div>

        <!-- ================= PERMISSIONS ================= -->
        <div>

          <div
            v-for="section in filteredSections"
            :key="section.code"
            class="permission-card"
          >

            <!-- HEADER -->
            <div class="permission-header">

              <div class="form-check d-flex align-items-center gap-2">

                <input
                  type="checkbox"
                  class="form-check-input"
                  :checked="isSectionChecked(section)"
                  @change="toggleSection(section)"
                />

                <label class="form-check-label fw-bold">
                  {{ section.label }}
                </label>

              </div>

              <button type="button"
                      class="btn btn-light btn-sm"
                      @click="toggleOpen(section.code)">
                <i class="bi"
                   :class="openSections.includes(section.code)
                     ? 'bi-chevron-up'
                     : 'bi-chevron-down'"></i>
              </button>

            </div>

            <!-- CHILDREN -->
            <div v-if="openSections.includes(section.code)"
                 class="permission-children">

              <div
                v-for="child in section.children"
                :key="child.code"
                class="form-check"
              >
                <input
                  type="checkbox"
                  class="form-check-input"
                  v-model="selectedPermissions"
                  :value="child.code"
                  @change="checkParent(section)"
                />

                <label class="form-check-label">
                  {{ child.label }}
                </label>
              </div>

            </div>

          </div>

        </div>

        <!-- SUBMIT -->
        <div class="text-end mt-4">

          <button class="btn btn-primary-medical px-4"
                  :disabled="isLoading">

            <span v-if="isLoading"
                  class="spinner-border spinner-border-sm me-2"></span>

            <i v-else class="bi bi-check-circle me-1"></i>

            Modifier le profil
          </button>

        </div>

      </form>

    </div>

  </div>
</template>

<script>
import api from "@/api";

export default {
  data() {
    return {
      roleName: "",
      search: "",
      selectedPermissions: [],
      openSections: [],
      isLoading: false,
      roleId: null,

      errors: {
        roleName: ""
      },

       sections: [
        {
          code: "DASHBOARD",
          label: "Tableau de bord",
          children: [
            { code: "DASH_VIEW", label: "Voir dashboard" }
          ]
        },
        {
          code: "PRODUITS",
          label: "Produits",
          children: [
            { code: "PRODUIT_LIST", label: "Liste produits" },
            { code: "PRODUIT_CREATE", label: "Créer produit" },
            { code: "PRODUIT_UPDATE", label: "Modifier produit" },
            { code: "PRODUIT_DELETE", label: "Supprimer produit" }
          ]
        },
        {
          code: "APPROVISIONNEMENT",
          label: "Approvisionnement",
          children: [
            { code: "APPROV_LIST", label: "Liste approvisionnements" },
            { code: "APPROV_CREATE", label: "Créer approvisionnement" },
            { code: "APPROV_UPDATE", label: "Modifier approvisionnement" },
            { code: "APPROV_DELETE", label: "Supprimer approvisionnement" },
            { code: "APPROV_BLOQUE", label: "Bloquer approvisionnement" },
            { code: "APPROV_DETAIL", label: "Détail approvisionnement" }
          ]
        },
      
        {
          code: "VENTES",
          label: "Ventes / Caisse",
          children: [
            { code: "VENTE_LIST", label: "Liste ventes" },
            { code: "VENTE_CREATE", label: "Nouvelle vente" },
            { code: "VENTE_PRINT", label: "Impression vente" },
            { code: "VENTE_CANCEL", label: "Annuler vente" },
            { code: "VENTE_EXPORT", label: "EXPORT " }
          ]
        },
        {
          code: "LOTS",
          label: "Lots",
          children: [
            { code: "LOT_LIST", label: "Liste lots" },
            
          ]
        },
        {
          code: "CONFIG",
          label: "Configuration",
          children: [
            { code: "CAT_LIST", label: "Catégories produits" },
            { code: "CAT_CREATE", label: "Création Catégories produits" },
            { code: "CAT_UPDATE", label: "Modifier Catégories produits" },
            { code: "CAT_DELETE", label: "Supprimer Catégories produits" },
            { code: "PAYMENT_METHOD", label: "Moyens de paiement" },
            { code: "PAYMENT_CREATE", label: "Création Moyens de paiement" },
            { code: "PAYMENT_UPDATE", label: "Modification Moyens de paiement" },
            { code: "PAYMENT_DELETE", label: "Supprimer Moyens de paiement" },

          ]
        },
        {
          code: "ADMIN",
          label: "Administration",
          children: [
            { code: "USER_LIST", label: "Utilisateurs" },
            { code: "USER_CREER", label: " Créer un Utilisateurs" },
            { code: "USER_UPDATE", label: " Modifier un Utilisateurs" },
            { code: "USER_LOCK", label: " Désactiver un Utilisateurs" },
            { code: "USER_DELETE", label: " Supprimer un Utilisateurs" },
            { code: "ROLE_LIST", label: "Rôles" },
            { code: "ROLE_CREATE", label: "Créer rôle" },
            { code: "ROLE_UPDATE", label: "Modifier rôle" },
            { code: "ROLE_DELETE", label: "Supprimer rôle" }
          ]
        }
      ]
    };
  },

  computed: {
    filteredSections() {
      if (!this.search) return this.sections;

      const q = this.search.toLowerCase();

      return this.sections
        .map(section => {
          const matchSection = section.label.toLowerCase().includes(q);

          const filteredChildren = section.children.filter(c =>
            c.label.toLowerCase().includes(q)
          );

          if (matchSection || filteredChildren.length) {
            return {
              ...section,
              children: matchSection ? section.children : filteredChildren
            };
          }

          return null;
        })
        .filter(Boolean);
    }
  },

  async created() {
    this.roleId = this.$route.params.id;
    await this.loadRole();
  },

  methods: {

    async loadRole() {
      const res = await api.getItem("type_users", this.roleId);
      const role = res.data;

      this.roleName = role.nom;
      this.selectedPermissions = role.permissions || [];
    },

    toggleOpen(code) {
      this.openSections = this.openSections.includes(code)
        ? this.openSections.filter(c => c !== code)
        : [...this.openSections, code];
    },

    isSectionChecked(section) {
      return section.children.every(c =>
        this.selectedPermissions.includes(c.code)
      );
    },

    toggleSection(section) {
      const all = this.isSectionChecked(section);

      if (all) {
        this.selectedPermissions =
          this.selectedPermissions.filter(
            p => !section.children.map(c => c.code).includes(p)
          );
      } else {
        section.children.forEach(c => {
          if (!this.selectedPermissions.includes(c.code)) {
            this.selectedPermissions.push(c.code);
          }
        });
      }
    },

    checkParent(section) {
      const has = section.children.some(c =>
        this.selectedPermissions.includes(c.code)
      );

      if (has && !this.selectedPermissions.includes(section.code)) {
        this.selectedPermissions.push(section.code);
      }

      if (!has) {
        this.selectedPermissions =
          this.selectedPermissions.filter(p => p !== section.code);
      }
    },

    selectAll() {
      this.selectedPermissions = [];

      this.sections.forEach(s => {
        this.selectedPermissions.push(s.code);
        s.children.forEach(c => this.selectedPermissions.push(c.code));
      });
    },

    clearAll() {
      this.selectedPermissions = [];
    },

    async submitForm() {
      if (!this.roleName.trim()) {
        this.errors.roleName = "Nom obligatoire";
        return;
      }

      this.isLoading = true;

      try {
        await api.updateItem("type_users", this.roleId, {
          nom: this.roleName,
          permissions: this.selectedPermissions
        });

        this.$router.push({ name: "role" });

      } finally {
        this.isLoading = false;
      }
    }

  }
};
</script>

<style scoped>

/* ================= PAGE ================= */
.role-medical-page {
  background: #f4f7fb;
  min-height: 100vh;
}

/* HEADER */
.page-header-medical {
  background: linear-gradient(135deg, #0f4c81, #071a2e);
  padding: 20px;
  border-radius: 18px;
  color: white;
}

/* TITLE */
.title-block {
  display: flex;
  gap: 15px;
  align-items: center;
}

.icon-box {
  width: 55px;
  height: 55px;
  border-radius: 14px;
  background: rgba(255,255,255,0.15);
  display: flex;
  align-items: center;
  justify-content: center;
}

/* CARD */
.medical-card {
  border: none;
  border-radius: 18px;
}

/* INPUT */
.form-control-medical {
  border-radius: 10px;
  border: 1px solid #dbe3ee;
}

/* PERMISSIONS */
.permission-card {
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  margin-bottom: 10px;
  background: white;
}

.permission-header {
  display: flex;
  justify-content: space-between;
  padding: 12px;
  background: #f8fafc;
}

.permission-children {
  padding: 12px 18px;
}

/* BUTTON */
.btn-primary-medical {
  background: #0f4c81;
  border: none;
  color: white;
  border-radius: 12px;
}

</style>